import { useContext, useEffect, useState } from 'react';
import SearchForm from 'src/components/network-analyst/SearchForm';
import INetworkAnalystSearchParams from 'src/types/INetworkAnalyst';
import * as networkAnalystService from 'src/services/networkAnalyst.service';
import * as notify from 'src/services/notification.service';
import { AppContext } from 'src/utils';

interface Props {
  type: 'business' | 'individual';
}

const NetworkAnalystPage: (props: Props) => JSX.Element = (props: Props) => {
  const { currentUser } = useContext(AppContext);
  const [hasLoaded, setHasLoaded] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [roles, setRoles] = useState<any>([]);

  useEffect(() => {
    setRoles([]);
    setHasLoaded(false);
  }, [props.type]);

  const search = (params: INetworkAnalystSearchParams) => {
    setRoles([]);
    setHasLoaded(false);
    setIsLoading(true);

    networkAnalystService
      .getNetworkIntelligence(
        props.type === 'business' ? 'organizationName' : 'fullName',
        params.name,
        params.country?.value ?? '',
        params.dateOfBirth ?? '',
      )
      // @ts-ignore
      .then((response) => {
        const data = response.data.data;
        setRoles(data.roles);
        setHasLoaded(true);
        setIsLoading(false);
      })
      .catch((err) => {
        if (!err.response.handled) {
          if (err.response && err.response.data && err.response.data.error.message) {
            notify.error(err.response.data.error.message);
          }
        }
        setHasLoaded(true);
        setIsLoading(false);
      })
  };

  return (
    <>
      <SearchForm 
        search={search}
        type={props.type}
      />

      <div className="row">
        <div className="col-lg-12 mt-10">
          <div className="card-title d-flex justify-content-between align-items-center">
            <h4>RESULTS</h4>
          </div>
        </div>

        {
          hasLoaded && !isLoading
          ? (
            roles.length
            ? (
              props.type === 'business'
              ? (
                <div className="col-lg-12 py-0">
                  <div className="container-table-network-analyst">
                    <table className="p-4">
                        <tr className="border-bottom">
                          <th colSpan={1} className="py-3 px-2 color-monoNormal"></th>
                          <th colSpan={1} className="py-3 px-2 color-monoNormal header-group border-left border-right">Subject</th>
                          <th colSpan={7} className="py-3 px-2 color-monoNormal header-group">Associated Organization</th>
                        </tr>
                        <tr className="border-bottom">
                          <th className="py-3 px-2 color-monoNormal">Role</th>
                          <th className="py-3 px-2 color-monoNormal border-left border-right">Name</th>
                          <th className="py-3 px-2 color-monoNormal">Name</th>
                          <th className="py-3 px-2 color-monoNormal">Country</th>
                          <th className="py-3 px-2 color-monoNormal">Start Date</th>
                          <th className="py-3 px-2 color-monoNormal">Legal Form</th>
                          <th className="py-3 px-2 color-monoNormal">Status</th>
                          <th className="py-3 px-2 color-monoNormal"></th>
                        </tr>
    
                        {
                          roles.map((role: any) => {
                            const roleDUNS = role.associatedOrganization.duns;
                            const roleCountryISO = role.associatedOrganization.address.addressCountry.isoAlpha2Code;
                            const screening = currentUser?.screening_disabled ? 'off' : 'on';
                            const companyProfileLink = `/company-report/detail?companyCode=${roleDUNS}&countryISO=${roleCountryISO}&screening=${screening}`;
    
                            return (
                              <tr className="border-bottom">
                                <td className="py-3 px-2">{role.roleType}</td>
                                <td className="py-3 px-2 border-left border-right">{role.primaryName}</td>
                                <td className="py-3 px-2">{role.associatedOrganization.primaryName}</td>
                                <td className="py-3 px-2">{role.associatedOrganization.address.addressCountry.name}</td>
                                <td className="py-3 px-2">{role.associatedOrganization.startDate}</td>
                                <td className="py-3 px-2">{role.associatedOrganization.legalForm.description}</td>
                                <td className="py-3 px-2">{role.associatedOrganization.dunsControlStatus.operatingStatus.description}</td>
                                <td className="py-3 px-2">
                                    <a href={companyProfileLink} target="_blank" rel="noreferrer">Report</a>
                                </td>
                              </tr>
                            );
                          })
                        }
                    </table>
                  </div>
                </div>
              ) : (
                <div className="col-lg-12 py-0">
                  <div className="container-table-network-analyst">
                    <table className="p-4">
                        <tr className="border-bottom">
                          <th colSpan={1} className="py-3 px-2 color-monoNormal"></th>
                          <th colSpan={2} className="py-3 px-2 color-monoNormal header-group border-left border-right">Subject</th>
                          <th colSpan={7} className="py-3 px-2 color-monoNormal header-group">Associated Organization</th>
                        </tr>
                        <tr className="border-bottom">
                          <th className="py-3 px-2 color-monoNormal">Role</th>
                          <th className="py-3 px-2 color-monoNormal border-left">Name</th>
                          <th className="py-3 px-2 color-monoNormal border-right">Date of Birth</th>
                          <th className="py-3 px-2 color-monoNormal">Name</th>
                          <th className="py-3 px-2 color-monoNormal">Country</th>
                          <th className="py-3 px-2 color-monoNormal">Start Date</th>
                          <th className="py-3 px-2 color-monoNormal">Legal Form</th>
                          <th className="py-3 px-2 color-monoNormal">Status</th>
                          <th className="py-3 px-2 color-monoNormal"></th>
                        </tr>
    
                        {
                          roles.map((role: any) => {
                            const roleDUNS = role.associatedOrganization.duns;
                            const roleCountryISO = role.associatedOrganization.address.addressCountry.isoAlpha2Code;
                            const screening = currentUser?.screening_disabled ? 'off' : 'on';
                            const companyProfileLink = `/company-report/detail?companyCode=${roleDUNS}&countryISO=${roleCountryISO}&screening=${screening}`;
    
                            return (
                              <tr className="border-bottom">
                                <td className="py-3 px-2">{role.roleType}</td>
                                <td className="py-3 px-2 border-left">{role.fullName}</td>
                                <td className="py-3 px-2 border-right">{role.birthDate}</td>
                                <td className="py-3 px-2">{role.associatedOrganization.primaryName}</td>
                                <td className="py-3 px-2">{role.associatedOrganization.address.addressCountry.name}</td>
                                <td className="py-3 px-2">{role.associatedOrganization.startDate}</td>
                                <td className="py-3 px-2">{role.associatedOrganization.legalForm.description}</td>
                                <td className="py-3 px-2">{role.associatedOrganization.dunsControlStatus.operatingStatus.description}</td>
                                <td className="py-3 px-2">
                                    <a href={companyProfileLink} target="_blank" rel="noreferrer">Report</a>
                                </td>
                              </tr>
                            );
                          })
                        }
                    </table>
                  </div>
                </div>
              )
            ) : (
              <div className="col-lg-12">
                <div className="card w-100">
                  <div className="py-8 text-center mx-auto mw-20">
                    <img
                      src={require('src/assets/images/empty-search.svg').default}
                      alt="empty-search"
                    />
                    
                    <p className="mt-8 color-monoNormal">
                      <div>No results found</div> <div>Please try another search</div>
                    </p>
                  </div>
                </div>
              </div>
            )
          ) : (
            <div className="col-lg-12">
              <div className="card w-100">
                <div className="py-8 text-center mx-auto mw-20">
                  <img
                    src={require('src/assets/images/placeholder-illustration.svg').default}
                    alt="Placeholder illustration"
                  />
                  <p className="mt-8 color-monoNormal">
                    {
                      !hasLoaded && isLoading
                      ? 'Loading . . .'
                      : 'Enter a name to see results'
                    }
                  </p>
                </div>
              </div>
            </div>
          )
        }
      </div>
    </>
  );
};

export default NetworkAnalystPage;
